<template>
  <el-container>
    <el-header style="text-align: right; font-size: 12px">
      <div class="logo_admin">
        <img src="../../public/imgs/3h-白底.png" alt="" srcset="" />
      </div>
      <el-dropdown @command="userCommand">
        <span style="margin-right: 20px">{{ item.username }}</span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="view">查看</el-dropdown-item>
          <el-dropdown-item command="add">新增</el-dropdown-item>
          <el-dropdown-item command="out">退出</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span></span>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <el-menu router unique-opened :default-active="$route.path">
          <el-submenu index="1">
            <template slot="title">
              <i class="el-icon-message"></i>
              分类管理
            </template>
            <el-menu-item-group title="分类管理">
              <el-menu-item index="/categories/school">网校创建</el-menu-item>
              <el-menu-item index="/categories/create">课程分类</el-menu-item>
              <el-menu-item index="/news/cate">新闻分类</el-menu-item>
              <el-menu-item index="/banner/cate">Banner分类</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="老师管理">
              <el-menu-item index="/teacher/create">创建老师</el-menu-item>
              <el-menu-item index="/teacher/list">查看老师</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="班级内容">
              <el-menu-item index="/price/create">创建班级</el-menu-item>
              <el-menu-item index="/price/list">查看班级</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="班次价格表">
              <el-menu-item index="/grade/create">创建班次表</el-menu-item>
              <el-menu-item index="/grade/list">查看班次表</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">
              <i class="el-icon-message"></i>
              内容管理
            </template>

            <el-menu-item-group title="目录管理">
              <el-menu-item index="/content/create">创建目录</el-menu-item>
              <el-menu-item index="/content/list">查看目录</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="试听管理">
              <el-menu-item index="/tvideo/create">创建试听</el-menu-item>
              <el-menu-item index="/tvideo/list">查看试听</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="考试大纲">
              <el-menu-item index="/outline/create">创建大纲</el-menu-item>
              <el-menu-item index="/outline/list">查看大纲</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="课程管理">
              <el-menu-item index="/lesson/create">创建课程</el-menu-item>
              <el-menu-item index="/lesson/list">查看课程</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="资料管理">
              <el-menu-item index="/files/create">上传文件</el-menu-item>
              <el-menu-item index="/files/list">查看文件</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="图书管理">
              <el-menu-item index="/books/create">创建图书</el-menu-item>
              <el-menu-item index="/books/list">查看图书</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="题库管理">
              <el-menu-item index="/tests/create">创建题库</el-menu-item>
              <el-menu-item index="/tests/list">查看题库</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="新闻管理">
              <el-menu-item index="/news/create">创建新闻</el-menu-item>
              <el-menu-item index="/news/list">查看新闻</el-menu-item>
            </el-menu-item-group>
          </el-submenu>

          <el-submenu index="3">
            <template slot="title"
              ><i class="el-icon-menu"></i>页面管理</template
            >
            <el-menu-item-group title="轮播图内容">
              <el-menu-item index="/banner/create">创建Banner</el-menu-item>
              <el-menu-item index="/banner/list">查看Banner</el-menu-item>
            </el-menu-item-group>
            <el-menu-item-group title="新闻内页Banner">
              <el-menu-item index="/newsbanner/create"
                >创建新闻Banner</el-menu-item
              >
              <el-menu-item index="/newsbanner/list"
                >查看新闻Banner</el-menu-item
              >
            </el-menu-item-group>
            <el-menu-item-group title="直播预告/回放">
              <el-menu-item index="/timeline/create">创建直播预告</el-menu-item>
              <el-menu-item index="/timeline/list">查看直播预告</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="报考指南">
              <el-menu-item index="/guide/create">报考指南</el-menu-item>
              <el-menu-item index="/guide/list">查看信息</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="备考指导">
              <el-menu-item index="/advice/create">备考指导</el-menu-item>
              <el-menu-item index="/advice/list">查看信息</el-menu-item>
            </el-menu-item-group>

            <el-menu-item-group title="详情介绍">
              <el-menu-item index="/about/create">创建介绍</el-menu-item>
              <el-menu-item index="/about/list">关于我们</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <el-submenu index="4">
            <template slot="title"
              ><i class="el-icon-menu"></i>系统管理</template
            >
            <el-menu-item-group>
              <template slot="title">管理员列表</template>
              <el-menu-item index="/admin/user">管理员账号</el-menu-item>
            </el-menu-item-group>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      item: "",
    };
  },
  methods: {
    async adminhome() {
      const user = await this.$http.get("/loginuser");
      const userdata = user.data.userinfo;
      this.item = userdata;
      //console.log(userdata);
    },
    async userCommand(command) {
      if (command == "view" || command == "add") {
        this.$router.push("/admin/user", () => {});
        //console.log("123");
      }
      if (command == "out") {
        localStorage.token = null;
        this.$router.push("/login");
        //console.log(localStorage.token);
      }
    },
  },
  created() {
    this.adminhome();
  },
};
</script>

<style scoped>
.el-header {
  position: relative;
  background-color: #b3c0d1;
  color: #333;
  height: 60px;
  line-height: 60px;
}

.el-aside {
  display: block;
  position: absolute;
  color: #333;
  top: 60px;
}
.el-main {
  position: absolute;
  left: 200px;
  right: 0;
  top: 60px;
  bottom: 0;
  overflow-y: scroll;
}
.logo_admin {
  display: flex;
  width: 35px;
  height: 35px;
  margin-top: 12.5px;
  float: left;
}

.logo_admin {
  display: flex;
  width: 35px;
  height: 35px;
  margin-top: 12.5px;
  float: left;
}
.logo_admin img {
  width: 136.5px;
}
</style>
